import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';
import { Fade } from 'react-reveal';
import {
  Menu,
} from '@uncinc/react-drupal-core';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import useValueForCurrentViewPort from '../../../helpers/useValueForCurrentViewPort';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import './style.scss';

const SECONDARY_DUTCH = 'secondary';
const SECONDARY_ENGLISH = 'en-secondary';

const SecondaryMenuOverlay = ({ onClick, when }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));
  const currentLanguage = useSelector((state) => state.getIn(['ui', 'language']));
  let menuId = SECONDARY_DUTCH;
  // Load a specific menu on english language for the Main corporate site
  if (currentLanguage !== DEFAULT_LANGUAGE) menuId = SECONDARY_ENGLISH;
  const delayForFade = useValueForCurrentViewPort(0, 250, 250, 250, 250);

  return (
    <Menu id={menuId}>
      {(items) => {
        return (
          <Fade bottom distance="50px" cascade duration={300} delay={delayForFade} when={when}>
            <div>
              {items.map((item, index) => {
                if (item) {
                  const title = item.getIn(['link', 'title'], 'Untitled');
                  const url = item.getIn(['link', 'url'], '');
                  const active = item.getIn(['link', 'url']) === currentPage;
                  const isCta = index === 0;
                  const SecondaryMenuOverlayItemClassnames = c('SecondaryMenuOverlay__item', {
                    'SecondaryMenuOverlay__item--active': active,
                  });

                  return (
                    <div key={title} className={SecondaryMenuOverlayItemClassnames}>
                      <Button
                        href={url}
                        className={`SecondaryMenuOverlay__item__link Button--block ${isCta ? 'Button--cta' : ''}`}
                        onClick={onClick}
                      >
                        <span className="SecondaryMenuOverlay__item__title">{title}</span>
                      </Button>
                    </div>
                  );
                }
              })}
            </div>
          </Fade>
        );
      }}
    </Menu>
  );
};

export default SecondaryMenuOverlay;
